/**
 * External dependencies
 */

/**
 * Internal dependencies
 */
import {
  SET_PROJECT_INITIALIZE,
  SET_PROJECT_LIST,
  SET_PROJECT_INFO
} from '@naruto/bgdapp/src/reducers/cores/project/actions';
import { errorCatch } from '@naruto/bgdapp/src/reducers/_Capture/errorCapture';
import {
  Dispatch,
  ThunkAction,
  Models,
  MiddleWare,
  ProjectList,
  ProjectListCondition,
  ProjectListAPICondition,
  ProjectInfo
} from './types';

/* Initial */
/**
 * 初始化管理 store 資料
 */
export const postProjectInitialize =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(SET_PROJECT_INITIALIZE());
  };

/**
 * 取得專案列表
 */
export const getProjectList =
  (condition: ProjectListCondition): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.project.getProjectList<ProjectList, ProjectListAPICondition>(condition.api);
    if (!result.error && result.response) {
      dispatch(SET_PROJECT_LIST({ list: result.response, condition }));
    } else {
      const oldState = getState().project.projectList;
      if (oldState) {
        dispatch(
          SET_PROJECT_LIST({
            list: { ...oldState.content },
            condition: { ...oldState.condition }
          })
        );
      } else {
        dispatch(
          SET_PROJECT_LIST({
            list: {
              list: []
            },
            condition: {
              api: {}
            }
          })
        );
      }
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 更新專案列表查詢條件
 */
export const postProjectListCondition =
  (condition: ProjectListCondition): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState): Promise<void> => {
    const oldState = getState().project.projectList;
    dispatch(SET_PROJECT_LIST({ list: { ...oldState.content }, condition }));
  };
/**
 * 取得專案資訊
 */
export const getProjectInfo =
  (projectID: string): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.project.getProjectInfo<ProjectInfo>(projectID);
    if (!result.error && result.response) {
      dispatch(SET_PROJECT_INFO({ projectID, projectInfo: result.response }));
    } else {
      const oldState = getState().project.projectInfos[projectID];
      if (oldState) {
        dispatch(SET_PROJECT_INFO({ projectID, projectInfo: { ...oldState } }));
      } else {
        dispatch(
          SET_PROJECT_INFO({
            projectID,
            projectInfo: {
              project: {
                id: projectID,
                ctime: '',
                mtime: ''
              }
            }
          })
        );
      }
    }
    await dispatch(errorCatch(result.error, result.status));
  };
